import { Link } from "react-router-dom";
import { Reveal, Label } from "@/components/motion";
import { ARTICLES } from "@/data/site";

export default function JournalTeaser() {
  const [lead, ...rest] = ARTICLES;

  return (
    <section data-testid="home-journal" className="border-t border-mist bg-white">
      <div className="mx-auto max-w-[1600px] px-6 py-28 lg:px-12 lg:py-40">
        <div className="flex flex-wrap items-end justify-between gap-8">
          <div>
            <Reveal>
              <Label>Journal</Label>
            </Reveal>
            <Reveal delay={0.08}>
              <h2 className="mt-6 font-serif text-4xl font-light leading-[1.0] tracking-tight text-ink sm:text-5xl">
                From the Journal
              </h2>
            </Reveal>
            <Reveal delay={0.14}>
              <p className="mt-4 max-w-md text-base text-steel">
                Stories, guides and inspiration for your next journey.
              </p>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <Link to="/journal" data-testid="journal-view-all" className="link-arrow text-ink hover:text-gold">
              View All Stories
              <span aria-hidden>→</span>
            </Link>
          </Reveal>
        </div>

        <div className="mt-16 grid gap-14 lg:grid-cols-12 lg:gap-10">
          <Reveal className="lg:col-span-7">
            <Link to={`/journal/${lead.slug}`} data-testid={`journal-card-${lead.slug}`} className="group block">
              <div className="overflow-hidden">
                <img
                  src={lead.hero}
                  alt={lead.title}
                  loading="lazy"
                  className="aspect-[16/10] w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-[1.03]"
                />
              </div>
              <p className="label mt-7 text-gold">{lead.category}</p>
              <h3 className="mt-3 max-w-lg font-serif text-3xl font-light leading-tight tracking-tight text-ink transition-colors group-hover:text-graphite sm:text-4xl">
                {lead.title}
              </h3>
              <p className="mt-3 max-w-lg text-[15px] leading-relaxed text-steel">{lead.excerpt}</p>
            </Link>
          </Reveal>
          <div className="flex flex-col gap-12 lg:col-span-5">
            {rest.map((a, i) => (
              <Reveal key={a.slug} delay={0.1 + i * 0.1}>
                <Link to={`/journal/${a.slug}`} data-testid={`journal-card-${a.slug}`} className="group grid grid-cols-5 gap-6">
                  <div className="col-span-2 overflow-hidden">
                    <img
                      src={a.hero}
                      alt={a.title}
                      loading="lazy"
                      className="aspect-[4/5] h-full w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-[1.05]"
                    />
                  </div>
                  <div className="col-span-3 flex flex-col justify-center">
                    <p className="label text-gold">{a.category}</p>
                    <h3 className="mt-3 font-serif text-2xl font-light leading-snug tracking-tight text-ink transition-colors group-hover:text-graphite">
                      {a.title}
                    </h3>
                    <span className="link-arrow mt-4 text-steel transition-colors group-hover:text-gold">
                      Read Story <span aria-hidden>→</span>
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
